module.exports = __webpack_public_path__ + "static/media/5-d.e00a6e00.jpg";